import { Flex, Popover, Stack, Text } from '@mantine/core';
import React from 'react';
import StyledButton from '@/components/StyledButton/StyledButton.tsx';
import DatasetPill from '@/pages/Run/components/DatasetPill.tsx';
import UrlCitationPill from '@/pages/Run/components/UrlCitationPill.tsx';
import { useHover } from '@mantine/hooks';
import { UrlCitation } from '@/types/extract.ts';
import { Dataset } from '@/types/datasets.ts';

type props = {
  dataset_citations: Dataset[];
  url_citations: UrlCitation[];
};

const CitationsMenu = ({ dataset_citations, url_citations }: props) => {
  const { hovered, ref } = useHover();

  const citationsLength = dataset_citations.length + url_citations.length;

  if (citationsLength === 0) {
    return <></>;
  }
  return (
    <Popover position="bottom-end" shadow="lg" width={'300px'} offset={4}>
      <Popover.Target ref={ref}>
        <StyledButton
          variant={'subtle'}
          size={'sm'}
          px={'6px'}
          py={'4px'}
          style={{
            borderRadius: '10px',
            height: '20px',
            backgroundColor: hovered ? '#EAEAEA' : '#f1f3f5',
          }}
        >
          <Text fw={400} size={'10px'}>
            {citationsLength === 1 ? '1 Source' : `${citationsLength} Sources`}
          </Text>
        </StyledButton>
      </Popover.Target>
      <Popover.Dropdown
        styles={{
          dropdown: {
            borderColor: 'var(--velos-brand-blue)',
            borderWidth: '1px',
            paddingLeft: '12px',
            paddingTop: '12px',
            paddingRight: '12px',
            paddingBottom: '12px',
          },
        }}
      >
        <Stack gap={'6px'}>
          {dataset_citations.map((dataset, index) => (
            <Flex key={`dataset-${index}`} justify={'flex-start'}>
              <DatasetPill datasetId={dataset.id} datasetName={dataset.name} dataset={dataset} />
            </Flex>
          ))}
          {url_citations.map((citation, index) => (
            <Flex key={`url-${index}`} justify={'flex-start'}>
              <UrlCitationPill url={citation.url} title={citation.title} />
            </Flex>
          ))}
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default CitationsMenu;
